import type { MapAnchor } from 'src/utils/mapViewport';

/** NPT-2264 — what the red flag is: the event's name on an event search, else "Search pin". */
export const anchorCaption = (anchor: Pick<MapAnchor, 'label' | 'isEvent'>, t: (key: string) => string) =>
   anchor.isEvent ? anchor.label : t('hotel.mapView.searchPin');

type Padding = { top: number; bottom: number; left: number; right: number };

/** fitBounds fails outright when padding leaves no room, so it never takes more than a third of a side. */
export const fitPadding = (container: HTMLElement | null, wanted: Padding): Padding => {
   const w = container?.clientWidth ?? 0;
   const h = container?.clientHeight ?? 0;
   const capW = (v: number) => (w ? Math.min(v, Math.floor(w / 3)) : v);
   const capH = (v: number) => (h ? Math.min(v, Math.floor(h / 3)) : v);
   return { top: capH(wanted.top), bottom: capH(wanted.bottom), left: capW(wanted.left), right: capW(wanted.right) };
};

/**
 * How far below the location icon's tip its box ends, as a share of the icon's height:
 * `location.svg` is 49 units tall with the tip at 40.25 (the rest is the ground shadow). A
 * bottom-anchored marker shifted down by this much puts the tip on the point. Pinned to the
 * SVG by a test, so a redrawn icon fails loudly instead of floating off its hotel.
 */
export const LOCATION_ICON_TIP_TO_BOTTOM = (49 - 40.25) / 49;

/**
 * Two bottom-anchored pins this close (in px, tip to tip) stack their captions on top of each
 * other; the search pin's caption gives way to the hotel's.
 */
export const pinCaptionsCollide = (a: { x: number; y: number }, b: { x: number; y: number }) =>
   Math.abs(a.x - b.x) < 140 && Math.abs(a.y - b.y) < 90;
